import React from 'react';

import Image from 'components/Image';

import { IntlMsgShape } from 'helpers/consts';

interface IProps {
  image: {
    alt: IntlMsgShape | string;
    src: string;
  };
}
const ImageWithGradient = ({ image }: IProps) => {
  return (
    <div className="ImageWithGradient relative inline-block">
      <Image alt={image.alt} src={image.src} className="w-full" />
      <div
        data-testid="bottom-image-gradient"
        className="absolute top-0 left-0 w-full h-full"
        style={{
          background:
            'linear-gradient(0deg, var(--color-soft-sensual-bg, #785a4d) 5%, rgba(255, 255, 255, 0) 15%)',
        }}
      />
    </div>
  );
};

export default ImageWithGradient;
